import React from "react";
import { motion } from "framer-motion";
import "./services.css";
import ServiceIcon from "./ServiceIcon";

const ServiceCard = ({ icon, title, description, delay }) => {
  return (
    <motion.div
      className="service-card"
      initial={{ opacity: 1, y: 0, scale: 1 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.3, delay }}
      whileHover={{
        y: -8,
        scale: 1.02,
        transition: { duration: 0.2 },
      }}
    >
      {/* Icon Container */}
      <div className="service-icon-wrapper">
        <ServiceIcon type={icon} />
      </div>

      {/* Content */}
      <div className="service-content">
        <h3 className="service-title">{title}</h3>
        <p className="service-description">{description}</p>
      </div>

      {/* Hover Glow Effect */}
      <div className="service-card-glow"></div>
    </motion.div>
  );
};

export default ServiceCard;

